export enum VDBIcons {
  REQUEST_HISTORY_DOT = "request-history-dot",
  ADD_CIRCLE = "add-circle",
  ADD_SAVED = "add-saved",
  ARROW_DOWN = "arrow-down",
  ARROW_LEFT = "arrow-left",
  ARROW_RIGHT = "arrow-right",
  ARROW_SCROLL_LEFT = "arrow-scroll-left",
  ARROW_SCROLL_RIGHT = "arrow-scroll-right",
  ARROW_UP = "arrow-up",
  ASK_REQUEST = "ask-request",
  ASSCHER = "asscher",
  ASSIGNED_USERS = "assigned-users",
  UNASSIGNED_USERS = "unassigned-users",
  ATTACH = "attach",
  BARCODE_SCANNER = "barcode-scanner",
  BAGUETTE = "baguette",
  BRAND = "brand",
  BRIOLETTE = "briolette",
  BULK_LIST_SHOPPING_CART = "bulk-list-shopping-cart",
  BULLET = "bullet",
  BUY = "buy",
  CABOCHON = "cabochon",
  CAMERA_ALT = "camera-alt",
  CAMERA = "camera",
  CHECK = "check",
  CHECKMARK = "checkmark",
  CIRCLE_DOWN = "circle-down",
  CIRCLE_LEFT = "circle-left",
  CIRCLE_RIGHT = "circle-right",
  CIRCLE_UP = "circle-up",
  CLOCK = "clock",
  CLOSE_CIRCLE = "close-circle",
  COLLECTION = "collection",
  COPY = "copy",
  COLLAPSE = "collapse",
  CUSH_BRILL = "cush-brill",
  CUSH_MOD = "cush-mod",
  DOCUMENT_UPLOAD = "document-upload",
  DOTS_MENU_FILLED = "dots-menu-filled",
  DOTS_MENU = "dots-menu",
  DOWN = "down",
  DRAG_ALT = "drag-alt",
  DRAG = "drag",
  EDIT = "edit",
  EMAIL = "email",
  EMERALD = "emerald",
  EURO_CUT = "euro-cut",
  EXPAND = "expand",
  EXTERNAL_LINK = "external-link",
  EYE_SLASH = "eye-slash",
  EYE = "eye",
  FACE_ID = "face-id",
  FACEBOOK = "facebook",
  FACETIME = "facetime",
  FAV = "fav",
  FAV_EMPTY = "fav-empty",
  FILLED_CIRCLE_DOWN = "filled-circle-down",
  FILLED_CIRCLE_LEFT = "filled-circle-left",
  FILLED_CIRCLE_RIGHT = "filled-circle-right",
  FILLED_CIRCLE_UP = "filled-circle-up",
  FILTER = "filter",
  FIND_A_MATCH = "find-a-match",
  FLANDERS = "flanders",
  FLASH_ON = "flash-on",
  FLASH_OFF = "flash-off",
  GLOBAL_SEARCH = "global-search",
  GRID = "grid",
  HALF_MOON = "half-moon",
  HEART = "heart",
  HEARTS_AND_ARROWS = "hearts-and-arrows",
  HEXAGONAL = "hexagonal",
  HOLD = "hold",
  HOME = "home",
  IMAGE = "image",
  INFO_COMMENT = "info-comment",
  INSTAGRAM = "instagram",
  KEY_SQUARE = "key-square",
  KITE = "kite",
  LEFT = "left",
  LINK = "link",
  LINKEDIN = "linkedin",
  LIST_EXPANDED = "list-expanded",
  LIST = "list",
  LOCATION = "location",
  LOGOUT = "logout",
  LOZENGE = "lozenge",
  MAIN_SEARCH = "main-search",
  MARQUISE = "marquise",
  MEMO = "memo",
  MESSAGE = "message",
  MIC = "mic",
  MINUS_CIRCLE = "minus-cirlce",
  MINIMIZE = "minimize",
  MORE = "more",
  OCTAGONAL = "octagonal",
  OLD_MINER = "old-miner",
  OVAL = "oval",
  PAYPAL = "paypal",
  PEAR = "pear",
  PENTAGONAL = "pentagonal",
  PLAY = "play",
  THREE_D_PLAY = "3d-play",
  THREE_D_PAUSE = "3d-pause",
  POINT = "point",
  PRICE_COMMENT = "price-comment",
  PRINCESS = "princess",
  PROFILE = "profile",
  PHONE_CALL = "phone-call",
  QUESTION_COMMENT = "question-comment",
  QUESTION = "question",
  QUOTE = "quote",
  RADIANT = "radiant",
  REPORT_ISSUE = "report-issue",
  REPORT_OLD = "report-old",
  REPORT = "report",
  REQUEST_HISTORY = "request-history",
  RIGHT = "right",
  ROSE_CUT = "rose-cut",
  ROUND = "round",
  SAVED_SEARCH_DONE = "saved-search-done",
  SAVED_SEARCHES = "saved-searches",
  SCAN = "scan",
  SEND = "send",
  SHARE_ALT = "share-alt",
  SHARE = "share",
  SHIELD = "shield",
  SNAPSHOT = "snapshot",
  SORT_ASCENDING = "sort-ascending",
  SORT_DESCENDING = "sort-descending",
  SORT = "sort",
  SQUARE = "square",
  STAR = "star",
  SWITCH_POSITIONS = "switch-positions",
  TABLE_SORT = "table-sort",
  TAPERED_BAGUETTE = "tapered-baguette",
  TOTAL_USERS = "total-users",
  TOUCH_ID = "touch-id",
  TRAPEZOID = "trapezoid",
  TRASH = "trash",
  TRILLIANT = "trilliant",
  UP = "up",
  UPD_DIAMONDS = "upd-diamonds",
  UPD_GEMSTONES = "upd-gemstones",
  UPD_JEWELRY = "upd-jewelry",
  UPD_LAB_GROWN = "upd-lab-grown",
  UPD_LAB_JEWELRY = "upd-lab-jewelry",
  VIDEO = "video",
  VIDEO_UNAVAILABLE = "video-unavailable",
  WARNING = "warning",
  WHATSAPP = "whatsapp",
  X_TWITTER = "x-twitter",
  YOUTUBE = "youtube",
  ARROW_RESET = "arrow-reset",
  CUSH_LONG = "cush-long",
  CUSH_SQUARE = "cush-square",
  THREE_D = "3D",
  SCREENSHOT = "screenshot",
  DOCUMENT_DOWNLOAD = "document-download",
  REFRESH_CIRCLE = "refresh-circle",
  PERCENTAGE_CIRCLE = "percentage-circle",
  PARCELS = "parcels",
}
